





























































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";
import MyList from "@/mixins/list";

import SelectUsers from "@/components/selectusers.vue";

@Component({
  components: {
    SelectUsers
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop({ default: "订单" }) modalTitle!: string;

  @Prop() modalParams!: any;

  dispatchType = "bill/getBills";

  curtime: number = moment().unix();

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", scopedSlots: { customRender: "username" } },
    { title: "订单类型", scopedSlots: { customRender: "bill_cate" } },
    {
      title: "订场信息",
      scopedSlots: { customRender: "orderinfo" }
    },
    { title: "下单时间", dataIndex: "created_time" },
    { title: "支付方式", dataIndex: "channel_name" },
    { title: "支付状态", scopedSlots: { customRender: "is_pay" } },
    { title: "订单状态", scopedSlots: { customRender: "bill_status" } }
  ];

  renderTime(dtime: string) {
    return moment(dtime).unix();
  }

  mounted() {
    // console.log(this.modalParams)
    this.searchData = { ...this.modalParams };
    this.loadData(
      {
        stadium_id: this.stadiumId,
        ...this.modalParams
      },
      false
    );
  }
}
